import React, { useRef, useEffect, useState } from "react";

export default function FiltroProaniOut({
  initialFilters = {},
  onClose = () => {},
  onSubmit = () => {},
}) {
  const filtroRef = useRef(null);

  // =========================
  // ESTADO
  // =========================
  const [dataFecha, setDataFecha] = useState(initialFilters.dataFecha ?? "");
  const [codigoTipo, setCodigoTipo] = useState(initialFilters.codigoTipo ?? "");
  const [nombreArchivo, setNombreArchivo] = useState(initialFilters.nombreArchivo ?? "");
  const [textoLinea, setTextoLinea] = useState(initialFilters.textoLinea ?? "");
  const [descricaoError, setDescricaoError] = useState(initialFilters.descricaoError ?? "");
  const [codigoProcesado, setCodigoProcesado] = useState(
    initialFilters.codigoProcesado ?? ""
  );

  // =========================
  // CERRAR CLICK FUERA / ESC
  // =========================
  useEffect(() => {
    const outside = (e) => {
      if (filtroRef.current && !filtroRef.current.contains(e.target)) {
        onClose();
      }
    };
    const esc = (e) => e.key === "Escape" && onClose();

    document.addEventListener("mousedown", outside);
    document.addEventListener("keydown", esc);
    return () => {
      document.removeEventListener("mousedown", outside);
      document.removeEventListener("keydown", esc);
    };
  }, [onClose]);

  // =========================
  // SUBMIT
  // =========================
  const handleSubmit = (e) => {
    e.preventDefault();

    const toNull = (v) =>
      String(v ?? "").trim() === "" ? null : String(v).trim();

    onSubmit({
      dataFecha: toNull(dataFecha),
      codigoTipo: toNull(codigoTipo),
      nombreArchivo: toNull(nombreArchivo),
      textoLinea: toNull(textoLinea),
      descricaoError: toNull(descricaoError),
      codigoProcesado: toNull(codigoProcesado),
    });
  };

  // =========================
  // RENDER
  // =========================
  return (
    <div className="drawer-backdrop">
      <div
        ref={filtroRef}
        onClick={(e) => e.stopPropagation()}
        className="drawer-panel overflow-auto"
      >
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-title">Filtros</h2>
          <button onClick={onClose} className="btn-cancel" title="Cerrar">
            ×
          </button>
        </div>

        <form onSubmit={handleSubmit} className="grid grid-cols-1 gap-4">

          {/* Fecha */}
          <div>
            <label className="form-label-fil">Fecha</label>
            <input
              type="date"
              className="input"
              value={dataFecha}
              onChange={(e) => setDataFecha(e.target.value)}
            />
          </div>

          {/* Código Tipo */}
          <div>
            <label className="form-label-fil">Código Tipo</label>
            <input
              className="input"
              maxLength={60}
              value={codigoTipo}
              onChange={(e) => setCodigoTipo(e.target.value)}
            />
          </div>

          {/* Nombre Archivo */}
          <div>
            <label className="form-label-fil">Nombre Archivo</label>
            <input
              className="input"
              maxLength={250}
              value={nombreArchivo}
              onChange={(e) => setNombreArchivo(e.target.value)}
            />
          </div>

          {/* Texto Línea */}
          <div>
            <label className="form-label-fil">Línea de Texto</label>
            <textarea
              className="input"
              rows={3}
              maxLength={600}
              value={textoLinea}
              onChange={(e) => setTextoLinea(e.target.value)}
            />
          </div>

          {/* Error */}
          <div>
            <label className="form-label-fil">Descripción Error</label>
            <input
              className="input"
              maxLength={200}
              value={descricaoError}
              onChange={(e) => setDescricaoError(e.target.value)}
            />
          </div>

          {/* Procesado */}
          <div>
            <label className="form-label-fil">Procesado</label>
            <select
              className="select"
              value={codigoProcesado}
              onChange={(e) => setCodigoProcesado(e.target.value)}
            >
              <option value="">— Todos —</option>
              <option value="SI">Sí</option>
              <option value="NO">No</option>
            </select>
          </div>

          <div className="text-right pt-2">
            <button type="submit" className="btn">
              Aplicar filtros
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
